var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "image-text-row container" }, [
    _c("div", { staticClass: "row d-flex align-items-stretch" }, [
      _c(
        "div",
        {
          staticClass:
            "col-12 col-lg-5 align-self-center pb-40 py-lg-80 py-xl-120 py-xxl-160"
        },
        [
          _c("h2", {
            staticClass: "mb-32",
            domProps: { innerHTML: _vm._s(_vm.title) }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "font-weight-light mb-32",
            domProps: { innerHTML: _vm._s(_vm.description) }
          }),
          _vm._v(" "),
          _vm.ctaLink
            ? _c(
                "a",
                {
                  staticClass: "btn btn-accent",
                  attrs: {
                    target: "_blank",
                    rel: "noopener",
                    href: _vm.ctaLink
                  }
                },
                [
                  _vm._v(_vm._s(_vm.cta) + " "),
                  _c("span", {
                    staticClass: "arrow-right",
                    domProps: { innerHTML: _vm._s(_vm.svg("arrow-right")) }
                  })
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-12 col-lg-6 offset-lg-1 align-self-stretch d-flex"
        },
        [
          _vm.image
            ? _c("img", {
                staticClass: "img-cover w-100 h-100 mt-30 mt-lg-0",
                attrs: { src: _vm.image }
              })
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }